import React, { Component } from 'react';
import Menu from '../../Elements/Menu/Menu';
import SmallMenu from '../../Elements/SmallMenu/SmallMenu';
import './index.css';



export default class Top extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: props.data,
			data2: props.data2,
			config: props.config
		}
	}

	render() {
		var element = null;

		if (this.state.config.top_component === "small_menu") {
			element = <SmallMenu data={this.state.data} data2={this.state.data2} config={this.state.config} />;
		} else if (this.state.config.top_component === "big_menu") {
			element = <SmallMenu data={this.state.data} data2={this.state.data2} config={this.state.config} />;
		}
		else if (this.state.config.top_component === "big_menu_list") {
			element = <SmallMenu data={this.state.data} data2={this.state.data2} config={this.state.config} />;
		}
		else if (this.state.config.top_component === "big_menu_6") {
			element = <SmallMenu data={this.state.data} data2={this.state.data2} config={this.state.config} />;
		}
		else {
			element = <Menu data={this.state.data} config={this.state.config} />;
		}

		return (
			<div className="header_top m-logo">
				{element}
			</div>
		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Header/Top/index.js